import * as React from "react";

class Footer extends React.Component<{}, {}> {
    render(): JSX.Element {
        return (
            <footer className="navbar-fixed-bottom navbar-inverse" style={ { textAlign: "center" } }>
                <p className="text-muted">
                    &nbsp;|&nbsp;
                    <a href="/setup">Getting started</a>
                    &nbsp;|&nbsp;
                    <a href="/support">Support</a>
                    &nbsp;|&nbsp;
                    <a href="/privacypolicy">Privacy policy</a>
                    &nbsp;|&nbsp;
                </p>
            </footer>
        );
    }
}

export default Footer;
